import { ITrackEventName } from '@wix/native-components-infra';
import { CartModel } from '../models/Cart.model';

export const trackInitiateCheckout = (cart: CartModel) => {
  const productsInfo = cart.lineItems?.map((item) => ({
    id: item.catalogReference?.catalogItemId,
    name: item.name,
    category: 'All Products',
    price: item.totalPrice?.amount,
    currency: cart.currency,
    quantity: item?.confirmedQuantity,
  }));

  return [
    'InitiateCheckout' as ITrackEventName,
    {
      contents: productsInfo,
      origin: 'Stores',
    },
  ] as [ITrackEventName, Record<string, any>];
};
